import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, PendingSalesListboxInfo } from '../sdk/sdk';

export interface PendingSale {
  id: string;
  appointmentId: string;
  quoteId: string;
  branch: string;
  customerName: string;
  holdDates: { date: string }[];
  saleDate: string;
  saleAmount: number;
  cfiName: string;
}

@Injectable({
  providedIn: 'root',
})
export class PendingSalesService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getPendingSales(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<PendingSalesListboxInfo> {
    return this.sdk.getPendingSales(branchIds, startDate, endDate);
  }
}
